<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <div id="main-container">
    <vx-card>
      <h4 class="mb-4">User Edit</h4>

      <div class="vx-row">

<!--        left column -->
        <div class="vx-col w-1/2">
          <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
              <vs-input class="w-full"
                        label-placeholder="First Name"
                        type="text"
                        v-model="user.first_name"/>
            </div>
            <div class="vx-col w-1/2">
              <vs-input class="w-full"
                        label-placeholder="Last Name"
                        type="text"
                        v-model="user.last_name"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="Email"
                        type="text"
                        v-model="user.email"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="Phone"
                        type="text"
                        v-model="user.phone"/>
            </div>
          </div>
        </div>


<!--        right column-->
        <div class="vx-col w-1/2">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="PayPal Email"
                        type="text"
                        v-model="user.paypal_email"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="Address"
                        type="text"
                        v-model="user.address"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full"
                        label-placeholder="Address 2"
                        type="text"
                        v-model="user.address_2"/>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
              <vs-input class="w-full"
                        label-placeholder="City"
                        type="text"
                        v-model="user.city"/>
            </div>

            <div class="vx-col w-1/2">
              <div class="vs-select--label" style="color: #626262;">State</div>

              <template>
                <v-select :options="statesForCountry" :value="user.state" v-on:input="stateChanged"/>
              </template>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
              <vs-input class="w-full"
                        label-placeholder="Postal Code}"
                        type="text"
                        v-model="user.postal_code"/>
            </div>

            <div class="vx-col w-1/2">
              <div class="vs-select--label" style="color: #626262;">Country</div>

              <template>
                <v-select :options="countries" :value="user.country" v-on:input="countryChanged"/>
              </template>
            </div>
          </div>
        </div>

      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-button @click="saveChanges">SAVE CHANGES</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {userHelpers} from '@/models/helpers';

  export default {
    components: {

    },
    mounted() {
      this.fetchUser();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        unsavedChanges: {},
        types: types,
        isLoading: false,
        user: new types.User(),
        showForgetButton: false,
        countries: userHelpers.getCountries().map((it) => {
          return {
            label: it.value,
            value: it.id,
          };
        }),
        countriesWithStates: userHelpers.getCountriesWithStates(),
        states: userHelpers.getStates(),
      }
    },
    computed: {
      userId() {
        return this.$route.query.id || null;
      },
      howManyUnsavedChanges() {
        let count = 0;
        let keys = Object.keys(this.unsavedChanges);
        for (let i = 0; i < keys.length; i++) {
          if (this.unsavedChanges[keys[i]]) {
            count++;
          }
        }
        return count;
      },
      statesForCountry() {
        if (this.countriesWithStates.includes(this.user.country)) {
          return this.states[this.user.country].map((it) => {
            if (this.user.country === 'GB') {
              return {
                label: it.value,
                value: it.value,
              };
            }

            return {
              label: it.value,
              value: it.id,
            };
          });
        }

        return [{ label: '_NOTLISTED_', value: '_NOTLISTED_' }];
      }
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
      async fetchUser() {
        this.$vs.loading();
        let user = await api.fetchUser(this.userId);
        if (user === null) {
          // todo: handle error
        }

        this.user = user;
        this.$vs.loading.close();
      },
      async stateChanged(newState) {
        this.user.state = newState.value;
      },
      async countryChanged(newCountry) {
        this.user.country = newCountry.value;
        this.user.state = this.statesForCountry[0].value;
      },
      async saveChanges() {
        let data = {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone: this.user.phone,
          paypal_email: this.user.paypal_email,
          address: this.user.address,
          address_2: this.user.address_2,
          city: this.user.city,
          state: this.user.state,
          country: this.user.country,
          postal_code: this.user.postal_code,
        };

        let user = await api.updateUser(this.userId, data);

        if (user === null) {
          this.showNotification(false, 'Could not save changes');
          return;
        }

        this.$router.push(`/users/detail?id=${this.userId}`).catch(()=> {});
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.howManyUnsavedChanges <= 0) {
        next();
      } else {
        // next(false);
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to leave this page? You will lose your unsaved changes.',
          accept: () => {
            next()
          }
        });
      }
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

